var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.height })},[_c('BarChartGenerator',{attrs:{"id":"fundraising-chart","options":_vm.options,"data":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }